// 城乡居民医疗保险缴费——微信，主流程
const wxMainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `insurance/wx/index${i + 1}`,
  name: `insuranceWxIndex${i + 1}`,
  component: () => import(`@/views/health/insurance/wx/index${i + 1}.vue`)
}))

// 城乡居民医疗保险缴费——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `insurance/zfb/index${i + 1}`,
  name: `insuranceZfbIndex${i + 1}`,
  component: () => import(`@/views/health/insurance/zfb/index${i + 1}.vue`)
}))

export default {
  path: '/health',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 城乡居民医疗保险缴费——微信，开始
    ...wxMainRoutes,

    // 城乡居民医疗保险缴费——支付宝，主流程
    ...zfbMainRoutes
  ]
}
